export default __webpack_public_path__ + "assets/21a9cc6d61e3e0c77e43df7ce857d678.png";